<mat-toolbar class="app-toolbar" color="primary">
  <button
    mat-icon-button
    type="button"
    (click)="onMenuToggle()"
    [attr.aria-label]="sidenavOpened ? 'Collapse navigation' : 'Expand navigation'"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <a class="brand-link" [routerLink]="homePage" aria-label="Go to dashboard">
    <span class="brand-title">Fidelity Insurance</span>
  </a>

  <span class="toolbar-title" [matTooltip]="applicationTitle">
    {{ applicationTitle }}
  </span>

  <span class="toolbar-spacer"></span>

  <button
    mat-icon-button
    type="button"
    (click)="callFullscreen()"
    aria-label="Toggle fullscreen"
  >
    <mat-icon>fullscreen</mat-icon>
  </button>

  <button
    mat-button
    type="button"
    [matMenuTriggerFor]="accountMenu"
    class="profile-trigger"
    aria-label="Open account menu"
  >
    <img [src]="userImg" class="profile-avatar" alt="User profile image" />
    <span class="profile-name" *ngIf="!isMobile">{{ userName }}</span>
    <mat-icon>expand_more</mat-icon>
  </button>
</mat-toolbar>

<mat-menu #accountMenu="matMenu">
  <button mat-menu-item routerLink="/account/update-profile">
    <mat-icon>person</mat-icon>
    <span>Account</span>
  </button>
  <button mat-menu-item type="button" (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
